/*
 * Copyright (c) 2020.
 * Simon
 */
import validator from 'validator';
import isValueEmpty from "./isValueEmpty";


export default function isURL(value) {
    if (isValueEmpty(value)) {
        return false;
    }

    return validator.isURL(value);
}
